import {createContext, useContext} from 'react';

export const TransitionPendingContext = createContext(false);

export const useRouterTransitionPending = (): boolean => useContext(TransitionPendingContext);
